<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Adicionar arquivo'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Selecionar arquivo -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-file-input
                      style="margin-top: 1.5em;"
                      id="uploadFileInput"
                      label="Clique aqui para selecionar o arquivo"
                      outlined
                      truncate-length="220"
                      chips
                      show-size
                      accept="application/pdf"
                      hint="O arquivo deve estar no formato PDF e pode ter no máximo 5 MB."
                      persistent-hint
                      :rules="obrigatorio"
                      @change="selecionaArquivo"
                    ></v-file-input>
                  </v-flex>
                </v-layout>

                <!-- Tipo do arquivo -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      style="margin-top: 1.5em;"
                      id="tipoArquivo"
                      label='Tipo do arquivo*'
                      :items="listaTipoArquivo"
                      v-model="arquivo.tipoArquivo"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      return-object
                      autocomplete
                      required
                      :rules="obrigatorio" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <!-- Observação -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea
                      class="observacao"
                      :label="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? 'Observação*' : 'Observação' : 'Observação'"
                      v-model="arquivo.observacao"
                      :rules="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? [...obrigatorio,...max200caracteres] : max200caracteres : max200caracteres"
                      :rows="2"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                      :hint="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? 'Informe o tipo de documento' : false : false"
                      :persistent-hint="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? true : false : false"
                     >
                    </v-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Adicionar" -->
            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>
              
              <!-- Botão "Adicionar" -->
              <v-btn color="primary" @click="adicionarArquivo()" :disabled="!formularioValido">Adicionar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: null,
        nivelAcesso: 'P'
      },
      listaTipoArquivo: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max200caracteres: [v => v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Função para ordenar lista de tipos de arquivos.
      funcaoOrdenaListaTiposArquivos: function (tipo1, tipo2) {
        return tipo1.item - tipo2.item
      },

      // Redireciona para a tela de visualização da aba "Arquivos" -->
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      },

      // Valida o arquivo selecionado.
      selecionaArquivo (file) {
        if (file.name.length > 200) {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: 'O nome do arquivo deve conter no máximo 200 caracteres!'})
          document.getElementById('uploadFileInput').value = ''
          return
        }
        this.arquivo.conteudo = file
        this.arquivo.nome = file.name
      },

      // Adiciona o aquivo ao projeto de pesquisa.
      adicionarArquivo () {
        let body = new FormData()
        body.append('arquivo', this.arquivo.conteudo)
        body.append('nome', this.arquivo.nome)
        body.append('observacao', this.arquivo.observacao)
        body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item)
        body.append('nivelAcesso', this.arquivo.nivelAcesso)

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando arquivo...' })
        projetos.postArquivoProjetoPesquisa(this.idProjetoPesquisa, body)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando arquivo...' })
        })
      },

      // Carrega tabela estruturada.
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
          aqui[atributo].sort(this.funcaoOrdenaListaTiposArquivos)
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' })
        })
      }
    },
    mounted () {
      // Carrega lista com os tipos de arquivos (COD_TABELA = 1170).
      this.opcoesTabelaEstruturada(1170, this, 'listaTipoArquivo')
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>

<style scoped>

  .observacao {
    margin-bottom: 2.0em;
  }

</style>



// WEBPACK FOOTER //
// adicionar-arquivo.vue?ab6fdb88